import { EDIT, CHANGEMODE } from "./actionTypes";

export const editForm = (data) => {
  return {
    type: EDIT,
    payload: data,
  };
};

export const changeSubmitMode = (mode) => {
  return {
    type: CHANGEMODE,
    payload: mode,
  };
};
